// import React, { useState, useEffect, useContext } from 'react';
// import { useParams } from 'react-router-dom';
// import NewsLeftSideSection from './newsLeftSideSection.jsx';
// import '../../../styles/category.css';
// import { DeviceContext } from '../index.jsx';
// import PageAds from '../../common/pageAds.jsx';

// const categoryMap = {

//   'latestnews-25.html': {
//     firstStep: 'LatestNews',
//     catId: 25,
//     pageTitle: 'Andhra Pradesh Top Story | Telugu Top Story News | Top Story | Top Story News',
//   },

//   'teluguoneexclusive-55.html': {
//     firstStep: 'TeluguOne Exclusive',
//     catId: 55,
//     pageTitle: 'TeluguOne Exclusive News | Andhra Pradesh Political News | AP Political News | Political Gossips',
//   },

//   'history-57.html': {
//     firstStep: 'History',
//     catId: 57,
//     pageTitle: 'Telugu History | Historical Stories | Andhra Pradesh History | TeluguOne',
//   },

//   'politics-39.html': {
//     firstStep: 'Politics',
//     catId: 39,
//     pageTitle: 'Andhra Pradesh Political News | AP Politics | Political News & Updates | TeluguOne',
//   },

//   'political-39.html': {
//     firstStep: 'Politics',
//     catId: 39,
//     pageTitle: 'Andhra Pradesh Political News | AP Politics | Political News & Updates | TeluguOne',
//   },

//   'analytical-45.html': {
//     firstStep: 'Analytical',
//     catId: 45,
//     pageTitle: 'Andhra Pradesh Analytical News | Political Analysis | TeluguOne',
//   },

//   'lifestyle-35.html': {
//     firstStep: 'lifestyle',
//     catId: 35,
//     pageTitle: 'Lifestyle News | Health, Fashion, Food & Lifestyle Tips | TeluguOne',
//   },

//   'health-34.html': {
//     firstStep: 'healthnews',
//     catId: 34,
//     pageTitle: 'Health News | Health Tips, Fitness, Diet & Wellness | TeluguOne',
//   },

//   'specialAnalysis-60.html': {
//     firstStep: 'specialAnalysis',
//     catId: 60,
//     pageTitle: 'Special Stories | Special Reports, Analysis & Insights | TeluguOne',
//   },

//   // Newly added categories

//   'andhrapradesh-43.html': {
//     firstStep: 'ఆంధ్రప్రదేశ్',
//     catId: 43,
//     pageTitle: 'Andhra Pradesh News | AP Latest News, Politics & Updates | TeluguOne',
//   },

//   'telangana-24.html': {
//     firstStep: 'తెలంగాణ',
//     catId: 24,
//     pageTitle: 'Telangana News | Latest Telangana News, Politics & Updates | TeluguOne',
//   },

//   'india-23.html': {
//     firstStep: 'భారత్',
//     catId: 23,
//     pageTitle: 'India News | Latest National News, Politics & Updates | TeluguOne',
//   },

//   'world-58.html': {
//     firstStep: 'ప్రపంచం',
//     catId: 58,
//     pageTitle: 'World News | Latest International News & Global Updates | TeluguOne',
//   },

//   'business-54.html': {
//     firstStep: 'బిజినెస్',
//     catId: 54,
//     pageTitle: 'Business News | Latest Business, Economy & Market Updates | TeluguOne',
//   },

//   'technology-33.html': {
//     firstStep: 'టెక్నాలజీ',
//     catId: 33,
//     pageTitle: 'Technology News | Latest Tech News, Gadgets & Digital Updates | TeluguOne',
//   },

//   'sports-53.html': {
//     firstStep: 'క్రీడలు',
//     catId: 53,
//     pageTitle: 'Sports News | Latest Sports News, Scores & Updates | TeluguOne',
//   },

// };


// const buildFallbackPageTitle = (type) => {
//   if (!type) return 'Latest News | TeluguOne';
//   const wordPart = type.replace(/-(\d+)\.html$/, '');
//   if (!wordPart) return 'Latest News | TeluguOne';
//   const readable = wordPart.replace(/[-_]+/g, ' ').trim();
//   if (!readable) return 'Latest News | TeluguOne';
//   const titleCased = readable
//     .split(' ')
//     .filter(Boolean)
//     .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
//     .join(' ');
//   return `${titleCased} News | TeluguOne`;
// };

// const CategoryNews = ({ data: serverData }) => {
//   const { type } = useParams();

// const mappedCategory = categoryMap[type];

// const urlCatIdMatch = type?.match(/-(\d+)\.html$/);


// const pagecatId = mappedCategory?.catId
//   || (urlCatIdMatch ? Number(urlCatIdMatch[1]) : null);

// const firstStep = mappedCategory?.firstStep || '';

// const pageTitle = mappedCategory?.pageTitle || buildFallbackPageTitle(type);

// // Truly invalid URL - no catId in categoryMap AND no id pattern in the URL at all
// const categoryNotFound = !pagecatId;
  
 
//   const initData = serverData?.[0] || {};
//   const [data, setData] = useState(initData.categoryMainData || null);
//   const [hasFetched, setHasFetched] = useState(false);
//   const [error, setError] = useState(initData.categoryMainError || null);
//   const [loading, setLoading] = useState(!initData.categoryMainData && !initData.categoryMainError);
//    const {mobile,containerRef} = useContext(DeviceContext)



 
 
 
 
// useEffect(() => {
//   let isActive = true;

//   const fetchCategoryData = async () => {
//     if (!pagecatId) return;

//     setLoading(true);
//     setError(null);

//     try {
//       const apiUrl =
//         `https://www.teluguone.com/news_api/catwiseNewsJson?catId=${pagecatId}` +
//         (firstStep
//           ? `&cat=${encodeURIComponent(firstStep)}`
//           : '');

//       const res = await fetch(apiUrl);

//       if (!res.ok) {
//         throw new Error(`HTTP error: ${res.status}`);
//       }

//       const jsonData = await res.json();

//       if (!isActive) return;

//       const newCategoryMainData = {
//         categoryNewsdata: jsonData.latestcatnews || [],
//         movienews: jsonData.movienews || [],
//         sidenewstwo: jsonData.analyticnews || [],
//         sidenewsthree: jsonData.varnews || [],
//         sidenewsfour: jsonData.catbasenews || [],
//         sidenewsfive: jsonData.healthnews || [],
//         catId: pagecatId,
//       };

//       setData(newCategoryMainData);
//       setError(null);
//       setLoading(false);

//     } catch (err) {

//       if (!isActive) return;

//       setError(
//         err.message || 'Something went wrong'
//       );

//       setData(null);
//       setLoading(false);
//     }
//   };

//   fetchCategoryData();

//   return () => {
//     isActive = false;
//   };

// }, [type, pagecatId, firstStep]);



//   useEffect(() => {
//     // Reset state when route changes
//     setHasFetched(false);
//     setData(initData.categoryMainData || null);
//     setError(initData.categoryMainError || null);
//   }, [type]);

//   if (categoryNotFound) {
//     return (
//       <div className='category-news-container d-flex justify-content-between mt-1'>
//         <div className='category-not-found-div' style={{ width: '100%', textAlign: 'center', padding: '40px 0' }}>
//           <p>Category Not Found</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className='category-news-container d-flex justify-content-between'>
      
      
//       <NewsLeftSideSection
//         categoryPageData={data}
    
//         error={error}
//         catId={data?.catId || pagecatId}
//         pageTitle={pageTitle}
       
//       />

//       <PageAds  mobile={mobile} containerRef={containerRef} />
//     </div>
//   );
// };

// export default CategoryNews;

import React, { useState, useEffect, useContext, useRef } from 'react';
import { useParams } from 'react-router-dom';
import NewsLeftSideSection from './newsLeftSideSection.jsx';
import '../../../styles/category.css';
import { DeviceContext } from '../index.jsx';
import PageAds from '../../common/pageAds.jsx';

const categoryMap = {

  'latestnews-25.html': {
    firstStep: 'LatestNews',
    catId: 25,
    pageTitle: 'Andhra Pradesh Top Story | Telugu Top Story News | Top Story | Top Story News',
  },

  'teluguoneexclusive-55.html': {
    firstStep: 'TeluguOne Exclusive',
    catId: 55,
    pageTitle: 'TeluguOne Exclusive News | Andhra Pradesh Political News | AP Political News | Political Gossips',
  },

  'history-57.html': {
    firstStep: 'History',
    catId: 57,
    pageTitle: 'Telugu History | Historical Stories | Andhra Pradesh History | TeluguOne',
  },

  'politics-39.html': {
    firstStep: 'Politics',
    catId: 39,
    pageTitle: 'Andhra Pradesh Political News | AP Politics | Political News & Updates | TeluguOne',
  },

  'political-39.html': {
    firstStep: 'Politics',
    catId: 39,
    pageTitle: 'Andhra Pradesh Political News | AP Politics | Political News & Updates | TeluguOne',
  },

  'analytical-45.html': {
    firstStep: 'Analytical',
    catId: 45,
    pageTitle: 'Andhra Pradesh Analytical News | Political Analysis | TeluguOne',
  },

  'lifestyle-35.html': {
    firstStep: 'lifestyle',
    catId: 35,
    pageTitle: 'Lifestyle News | Health, Fashion, Food & Lifestyle Tips | TeluguOne',
  },

  'health-34.html': {
    firstStep: 'healthnews',
    catId: 34,
    pageTitle: 'Health News | Health Tips, Fitness, Diet & Wellness | TeluguOne',
  },

  'specialAnalysis-60.html': {
    firstStep: 'specialAnalysis',
    catId: 60,
    pageTitle: 'Special Stories | Special Reports, Analysis & Insights | TeluguOne',
  },

  'andhrapradesh-43.html': {
    firstStep: 'ఆంధ్రప్రదేశ్',
    catId: 43,
    pageTitle: 'Andhra Pradesh News | AP Latest News, Politics & Updates | TeluguOne',
  },

  'telangana-24.html': {
    firstStep: 'తెలంగాణ',
    catId: 24,
    pageTitle: 'Telangana News | Latest Telangana News, Politics & Updates | TeluguOne',
  },

  'india-23.html': {
    firstStep: 'భారత్',
    catId: 23,
    pageTitle: 'India News | Latest National News, Politics & Updates | TeluguOne',
  },

  'world-58.html': {
    firstStep: 'ప్రపంచం',
    catId: 58,
    pageTitle: 'World News | Latest International News & Global Updates | TeluguOne',
  },

  'business-54.html': {
    firstStep: 'బిజినెస్',
    catId: 54,
    pageTitle: 'Business News | Latest Business, Economy & Market Updates | TeluguOne',
  },

  'technology-33.html': {
    firstStep: 'టెక్నాలజీ',
    catId: 33,
    pageTitle: 'Technology News | Latest Tech News, Gadgets & Digital Updates | TeluguOne',
  },

  'sports-53.html': {
    firstStep: 'క్రీడలు',
    catId: 53,
    pageTitle: 'Sports News | Latest Sports News, Scores & Updates | TeluguOne',
  },

};


// ======================================================
// FALLBACK PAGE TITLE
// ======================================================

const buildFallbackPageTitle = (type) => {

  if (!type) {
    return 'Latest News | TeluguOne';
  }

  const wordPart = type.replace(/-(\d+)\.html$/, '');

  if (!wordPart) {
    return 'Latest News | TeluguOne';
  }

  const readable = wordPart
    .replace(/[-_]+/g, ' ')
    .trim();

  if (!readable) {
    return 'Latest News | TeluguOne';
  }

  const titleCased = readable
    .split(' ')
    .filter(Boolean)
    .map(
      (w) =>
        w.charAt(0).toUpperCase() + w.slice(1)
    )
    .join(' ');

  return `${titleCased} News | TeluguOne`;
};


// ======================================================
// COMPONENT
// ======================================================

const CategoryNews = ({ data: serverData }) => {

  const { type } = useParams();

  const { mobile, containerRef } =
    useContext(DeviceContext);


  // ====================================================
  // CATEGORY INFORMATION
  // ====================================================

  const mappedCategory = categoryMap[type];

  const urlCatIdMatch =
    type?.match(/-(\d+)\.html$/);

  const pagecatId =
    mappedCategory?.catId ||
    (urlCatIdMatch
      ? Number(urlCatIdMatch[1])
      : null);

  const firstStep =
    mappedCategory?.firstStep || '';

  const pageTitle =
    mappedCategory?.pageTitle ||
    buildFallbackPageTitle(type);

  const categoryNotFound = !pagecatId;


  // ====================================================
  // SSR DATA
  // ====================================================

  const initData = serverData?.[0] || {};

  const initialCategoryData =
    initData.categoryMainData || null;

  const initialError =
    initData.categoryMainError || null;


  // ====================================================
  // STATE
  // ====================================================

  const [data, setData] = useState(
    initialCategoryData
  );

  const [loading, setLoading] = useState(
    !initialCategoryData && !initialError
  );

  const [error, setError] = useState(
    initialError
  );


  // ====================================================
  // TRACK INITIAL ROUTE
  // ====================================================

  const firstRenderRef = useRef(true);


  // ====================================================
  // FETCH CATEGORY DATA
  // ====================================================

  useEffect(() => {

    let isActive = true;

    const fetchCategoryData = async () => {

      if (!pagecatId) {
        return;
      }


      // -----------------------------------------------
      // CLIENT-SIDE CATEGORY CHANGE
      // -----------------------------------------------

      if (!firstRenderRef.current) {

        // IMPORTANT:
        // Remove previous category immediately.
        // This prevents old category flickering.

        setData(null);
        setError(null);
        setLoading(true);
      }


      try {

        const apiUrl =
          `https://www.teluguone.com/news_api/catwiseNewsJson?catId=${pagecatId}` +
          (
            firstStep
              ? `&cat=${encodeURIComponent(firstStep)}`
              : ''
          );


        const res = await fetch(apiUrl);


        if (!res.ok) {
          throw new Error(
            `HTTP error: ${res.status}`
          );
        }


        const jsonData =
          await res.json();


        if (!isActive) {
          return;
        }


        const newCategoryMainData = {

          categoryNewsdata:
            jsonData.latestcatnews || [],

          movienews:
            jsonData.movienews || [],

          sidenewstwo:
            jsonData.analyticnews || [],

          sidenewsthree:
            jsonData.varnews || [],

          sidenewsfour:
            jsonData.catbasenews || [],

          sidenewsfive:
            jsonData.healthnews || [],

          catId: pagecatId,
        };


        setData(
          newCategoryMainData
        );

        setError(null);

        setLoading(false);

      } catch (err) {

        if (!isActive) {
          return;
        }

        setData(null);

        setError(
          err.message ||
          'Something went wrong'
        );

        setLoading(false);
      }
    };


    // -----------------------------------------------
    // Initial SSR render
    // -----------------------------------------------

    if (firstRenderRef.current) {

      firstRenderRef.current = false;


      // If SSR already provided data,
      // don't fetch immediately.

      if (initialCategoryData) {
        return () => {
          isActive = false;
        };
      }
    }


    fetchCategoryData();


    return () => {
      isActive = false;
    };

  }, [type, pagecatId, firstStep]);


  // ====================================================
  // INVALID CATEGORY
  // ====================================================

  if (categoryNotFound) {

    return (
      <div className="category-news-container d-flex justify-content-between mt-1">

        <div
          className="category-not-found-div"
          style={{
            width: '100%',
            textAlign: 'center',
            padding: '40px 0'
          }}
        >

          <p>
            Category Not Found
          </p>

        </div>

      </div>
    );
  }


  // ====================================================
  // RENDER
  // ====================================================

  return (

    <div className="category-news-container d-flex justify-content-between">

      <NewsLeftSideSection
        key={pagecatId}
        categoryPageData={data}
        error={error}
        catId={pagecatId}
        pageTitle={pageTitle}
        parentLoading={loading}
      />


      <PageAds
        mobile={mobile}
        containerRef={containerRef}
      />

    </div>
  );
};


export default CategoryNews;
